import { makeStyles, type Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  introDetails: {
    margin: "20px 0px 30px 0px",
    "& img": {
      width: "95%",
      maxHeight: "100%",
    },
  },
  intro: {
    color: "#0F172A",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(23),
  },
  body: {
    color: "#000000",
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(22),
  },
}));
